import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnablePrinterFiltering = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enablePrinterFiltering);
};
